export default "__VITE_ASSET__B$Wk7anp__"